import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { BLUE, GREEN, RED, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import OfficeRndActivationForm from '../../forms/Integrations/OfficeRndActivationForm.jsx';
import Office365ActivationForm from '../../forms/Integrations/Office365ActivationForm.jsx';
import { IconButton } from '@material-ui/core';
import ArrowLeftIconCustom from '../../CustomIcons/ArrowLeftIconCustom.jsx';
import Office365SelectCalendarForm from '../../forms/Integrations/Office365SelectCalendarForm.jsx';


@connect(state => ({ language: state.settings.language }))
class Office365SettingsOperationalSection extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
      microsoftData: {
        clientId: null,
        clientSecret: null,
        tenantId: null,
        calendarId: null,
        userId: null
      },
      calendards: null
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const isActive = dispatch(UserActions.userHasIntegrationActive(SUBSCRIPTION_TYPES.OFFICE365_INTEGRATION));
    this.setState({ isActive });
  }

  async onSumbitOffice365Data(formData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const { calendars, userId } = await dispatch(UserActions.loginWithOffice365AndGetCalendars(formData.clientId, formData.clientSecret, formData.tenantId, formData.principalEmail));
      this.setState({ microsoftData: { ...formData, userId }, calendars });
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionError" /></h6>),
        },
      }));
    }
  }

  async onActivateMicrosoftCalendarActivation(calendarsData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const { clientId, clientSecret, tenantId, userId } = this.state.microsoftData;
      const calendarId = calendarsData;
      await dispatch(UserActions.activateMicrosoftIntegration(clientId, clientSecret, tenantId, userId, calendarId));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(UserActions.fetchCurrentActiveIntegrations());
      this.setState({ isActive: true });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionError" /></h6>),
        },
      }));
    }
  }

  onDeactivateIntegrationRequest() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="disableIntegrationConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeactivateIntegration(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeactivateIntegration() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const officeIntegrationDTO = dispatch(UserActions.getActiveIntegration(SUBSCRIPTION_TYPES.OFFICE365_INTEGRATION));
      if (officeIntegrationDTO && officeIntegrationDTO.id) {
        await dispatch(UserActions.disableIntegration(officeIntegrationDTO.id));
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(UserActions.fetchCurrentActiveIntegrations());
        this.setState({ isActive: false });
        dispatch(ModalActions.showModal({
          modalType: 'SUCCESS_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
          },
        }));
      } else {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
          },
        }));
      }
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { isActive, calendars } = this.state;
    const { dispatch } = this.props;
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25, paddingTop: 10, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img alt="microsoft" src="/imgs/common/integrationLogos/microsoft-logo.png" style={{ width: 100, alignSelf: 'center' }} />
        {isActive ? (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <div style={{ width: '70%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CheckOutlineIconCustom style={{ color: GREEN, width: 30, marginRight: 10 }} />
              <h4 style={{ color: GREEN, fontWeight: 'bold', fontSize: 20 }}><Entity entity="integrationCorrectlyConfigured" /></h4>
            </div>
            <MDButton
              title={<Entity key={isActive} entity="disableIntegrationTitle" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={RED}
              containerStyle={{ margin: 0, marginTop: 10, width: '80%' }}
              onClick={() => this.onDeactivateIntegrationRequest()}
            />
          </div>
        ) : (
          <div style={{ width: '70%', margin: 'auto' }}>
            <h4 style={{ color: '#3f3f3f', textAlign: 'center', marginTop: 20, marginBottom: 30 }}><Entity entity="connectOffice365Description" /></h4>
            {!calendars ? (
              <div>
                <div style={{ marginTop: 20 }}>
                  <Office365ActivationForm
                    onSubmit={loginData => this.onSumbitOffice365Data(loginData)}
                  />
                </div>
                <MDButton
                  title={<Entity entity="login" key={calendars} />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor={BLUE}
                  containerStyle={{ margin: 0, marginTop: 10, marginBottom: 10 }}
                  onClick={() => dispatch(submit('Office365ActivationForm'))}
                />
                 <h5
                  className="link-label"
                  style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
                  onClick={() => window.open('https://dev.to/davelosert/practical-guide-to-use-the-microsoft-graph-api-4ahn')}
                >
                  <Entity entity="findOutMore" />
                </h5>
              </div>
            ) : (
              <div>
                <div style={{ marginTop: 20 }}>
                  <Office365SelectCalendarForm
                    calendars={calendars}
                    onSubmit={calendarsData => this.onActivateMicrosoftCalendarActivation(calendarsData.calendars)}
                  />
                </div>
                <MDButton
                  title={<Entity key={calendars} entity="connectYourAccount" />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor={BLUE}
                  containerStyle={{ margin: 0, marginTop: 10 }}
                  onClick={() => dispatch(submit('Office365SelectCalendarForm'))}
                />
                <IconButton onClick={() => this.setState({ calendars: null })}>
                  <ArrowLeftIconCustom style={{ color: '#3f3f3f', width: 20, marginRight: 5 }} />
                </IconButton>
                <Entity style={{ color: '#3f3f3f', marginTop: 2 }} entity="backToLogin" />
              </div>
          )}
          </div>
        )}
      </div>
    );
  }
}

export default Office365SettingsOperationalSection;
